import React from 'react';

export function Dots(props) {
  const { fill = '#000000', ...otherProps } = props;
  return (
    <svg {...otherProps} width='262' height='202' viewBox='0 0 262 202' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='1.95389' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='1.95389' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='21.7947' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='41.6355' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='61.4763' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='81.3172' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='101.158' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='120.999' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='140.841' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='160.681' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='180.522' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='200.363' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='220.204' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='240.045' cy='200.274' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='1.86543' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='21.7063' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='41.5472' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='61.3881' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='81.229' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='101.07' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='120.911' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='140.752' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='160.593' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='180.433' r='1.48807' fill={fill} />
      <circle cx='259.886' cy='200.274' r='1.48807' fill={fill} />
    </svg>
  );
}
